/** @jsxRuntime automatic */
/** @jsxImportSource react */
// FOUNDATION §12 — prefers-reduced-motion / no-WebGL: the argument survives as a static
// vertical sequence: the WEBSITE_COPY.md copy plus the concept render as hero.
export function Fallback() {
  return (
    <article className="fallback">
      <header>
        <img src="/assets/logo.png" alt="Random Monkey" width="155" height="60" style={{ width: 'auto', height: '40px', marginBottom: '1rem' }} />
        <h1>Random Monkey</h1>
        <p>Enough monkeys. Enough time.</p>
      </header>
      <img src="/background.png" alt="An endless white office of monkeys typing at desks, streams of letters rising from every screen." />
      <section>
        <p>A monkey at a typewriter will eventually write Shakespeare. Infinitely true, infinitely unuseful&hellip; until now.</p>
        <p><strong>Randomness produces everything and nothing.</strong> More generation doesn&rsquo;t get you closer to the one you wanted. It buries it deeper.</p>
        <p><strong>Something has to catch it.</strong> Raw output has to be captured, routed, and given a shape before a person or an agent can do anything with it.</p>
        <p><strong>Structure is the scarce thing.</strong> Generation is cheap and getting cheaper. What&rsquo;s hard is data that knows what it is. That&rsquo;s the part we build.</p>
        <p><strong>Typed. Structured. Yours.</strong> Everything downstream is a view of the source, none of it drifting from it.</p>
        <p><strong>What you build with it stays built.</strong> Open formats, a readable history, no lock-in.</p>
        <p className="three-ways">Three ways in.</p>
      </section>
      <nav className="products" aria-label="Products">
        <a href="https://datasketch.co">
          <span aria-hidden="true">&#9679;</span> <strong>Datasketch</strong> — One place for your organization&rsquo;s data, and everything you make from it.
        </a>
        <a href="https://monkeyplex.app">
          <span aria-hidden="true">&#9679;</span> <strong>MonkeyPlex</strong> — Docs, tables, chat and slides, where AI agents are actual coworkers.
        </a>
        <a href="https://miqqa.ai">
          <span aria-hidden="true">&#9679;</span> <strong>Miqqa</strong> — An agent that does the data work — cleaning it, typing it, transforming it.
        </a>
      </nav>
    </article>
  )
}
